import React, { memo } from 'react';
import {
    Image,
    Icon,
    Flex,
    useColorModeValue,
    Text,
    Box,
    theme,
    IconButton,
} from "@chakra-ui/react";
import { motion } from "framer-motion"
import { ImCross } from "react-icons/im";
import { textStyle } from 'theme/names';

interface Props {
    id: string;
    removeImage: (id: string) => void;
    onClick?: () => void;
}

export const ImageThumbnail = ({ id, removeImage, onClick }: Props) => {

    const [size, setSize] = React.useState("small");
    const isNotImage = id.includes("vid-") || id.includes("gif-");
    return (
        <motion.div
            animate={{
                width: size == "small" ? "40px" : "150px",
                height: size == "small" ? "40px" : "150px",
            }}
            transition={{
                duration: 0.1,
                ease: "easeOut", // "linear" "easeIn", "easeOut", "easeInOut" "circIn", "circOut", "circInOut" "backIn", "backOut", "backInOut" "anticipate"
            }}
            style={{
                marginRight: "8px",
                minWidth: size == "small" ? "32px" : "150px",
                // position: size == "small" ? "relative" : "absolute",
                // right: size == "small" ? "0" : "-10px",
                // top: size == "small" ? "0" : "0px",
                zIndex: size == "small" ? 0 : 20,
                cursor: onClick ? (isNotImage ? "default" : "pointer") : "default"
            }}
            key={id}
            onClick={() => {
                onClick && onClick();
            }}
        >
            <Flex
                h="100%"
                w="100%"
                position="relative"
                p={size == "small" ? "0" : 1}
                bg={useColorModeValue("gray.800", "gray.100")}
                // border={size == "small" ? "none" : "solid 1px " + useColorModeValue(theme.colors.gray[100], theme.colors.gray[800])}
                borderRadius="10px"
                flexDirection="column"
                // justifyContent="center"
                alignItems="center"
                onMouseEnter={() => {
                    setSize("large");
                }}
                onMouseLeave={() => {
                    setSize("small");
                }}
            >
                {
                    size == "large" && (
                        <Flex w="100%" position="absolute" justifyContent="flex-end">
                            {/* <Text textStyle={textStyle["body.medium.light"]} fontSize="sm" m={2} color={useColorModeValue("gray.100", "gray.800")}>
                                {"[img:" + id + "]"}
                            </Text> */}
                            <IconButton
                                m={1}
                                mr={2}
                                size="xs"
                                // variant="ghost"
                                border="solid 3px #1E1E1E"
                                aria-label="cancel DM"
                                icon={<ImCross fontSize="8px" />}
                                onClick={async (e) => {
                                    e.stopPropagation();
                                    removeImage && removeImage(id);
                                }}
                            />
                        </Flex>
                    )
                }
                {
                    id.includes("vid-") ? (
                        size == "large" && (
                            <Text textStyle={textStyle["body.medium.light"]} color="white">[video]</Text>
                        )
                    ) : (
                        id.includes("doc-") ? (
                            size == "large" && (
                                <Text textStyle={textStyle["body.medium.light"]} color="white">[pdf doc]</Text>
                            )
                        ) : (
                            <Image
                                src={"https://ez4cast.s3.eu-west-1.amazonaws.com/userUpload/" + id + `#dt=${Math.floor(Math.random() * 100000).toString()}`}
                                h="100%"
                                w="100%"
                                borderRadius="10px"
                                objectFit="cover"
                                fit="cover"
                                overflow="hidden"
                            />
                        )
                    )
                }
            </Flex>
        </motion.div>
    )
}